/**
 * SQL cast used to read/filter each type out of the `custom_attributes` JSONB column. `multi_select`
 * reads as a Postgres `text[]` (its JSON array of option keys) so it can be filtered with array
 * operators. `null` for types that are not read-castable (`lookup_relational`).
 */
export const CUSTOM_ATTRIBUTE_READ_CAST = {
    short_text: '::text',
    multi_line_text: '::text',
    url: '::text',
    number: '::numeric',
    checkbox: '::boolean',
    dropdown: '::text',
    date: '::timestamptz',
    date_time: '::timestamptz',
    multi_select: '::text[]',
    lookup_relational: null,
};
/**
 * Whether `value` is a known `CustomAttributeType`. Keyed off `CUSTOM_ATTRIBUTE_READ_CAST`, which
 * `satisfies Record<CustomAttributeType, …>`, so the guard can never drift from the union.
 */
export function isCustomAttributeType(value) {
    return typeof value === 'string' && value in CUSTOM_ATTRIBUTE_READ_CAST;
}
